import { type VirtualItem } from "@tanstack/react-virtual";

const MAX_CACHED_ROOMS = 20;

type SavedMeasurement = {
  key: VirtualItem["key"];
  size: number;
};

interface CachedRoom {
  width: number;
  items: VirtualItem[];
}

const cachedByRoom = new Map<string, CachedRoom>();

function normalize(item: SavedMeasurement): VirtualItem {
  return {
    key: item.key,
    index: 0,
    start: 0,
    end: 0,
    size: item.size,
    lane: 0,
  };
}

export function saveRowSizes(
  roomId: string,
  width: number,
  items: ReadonlyArray<SavedMeasurement>,
): void {
  cachedByRoom.delete(roomId);
  cachedByRoom.set(roomId, {
    width,
    items: items.map(normalize),
  });
  if (cachedByRoom.size > MAX_CACHED_ROOMS) {
    const oldest = cachedByRoom.keys().next().value;
    if (oldest !== undefined) cachedByRoom.delete(oldest);
  }
}

export function loadRowSizes(roomId: string, width: number): VirtualItem[] {
  const entry = cachedByRoom.get(roomId);
  if (!entry) return [];
  cachedByRoom.delete(roomId);
  cachedByRoom.set(roomId, entry);
  if (entry.width !== width) return [];
  return entry.items.slice();
}
